import React, { useEffect, useId } from "react";
import { useUnmountEffect } from "framer-motion";

import { DialogRoot } from "@ui/Molecules/Dialog";

import { GenericPortal } from "@containers/GenericPortal";

import { DialogManagerProps } from "./DialogManager.types";
import { useManager } from "./DialogManager.hooks";

export const DialogManager: React.FC<DialogManagerProps> = ({
  id,
  onRequestClose,
  isSingleInstance,
  ...props
}) => {
  const renderId = useId();

  const {
    isDialogActive,
    hideDialog,
    isManagerInstanceRendered: isDialogInstanceRendered,
    setManagerRenderedInstance: setDialogRenderedInstance,
  } = useManager();

  useEffect(() => {
    if (!isDialogInstanceRendered(id, renderId)) {
      setDialogRenderedInstance(id, renderId);
    }
  }, []);

  useUnmountEffect(() => {
    hideDialog(id);
  });

  if (isSingleInstance && isDialogInstanceRendered(id, renderId)) {
    return null;
  }

  return (
    <GenericPortal.Portal type="dialog">
      {isDialogActive(id) && (
        <DialogRoot onRequestClose={onRequestClose.bind(null, id)} {...props} />
      )}
    </GenericPortal.Portal>
  );
};
